import React, { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import {
  Container,
  Button,
  Row,
  Col,
  Table,
  Form,
  Spinner,
} from "react-bootstrap";
import EditNoteIcon from "@mui/icons-material/EditNote";
import DeleteSweepIcon from "@mui/icons-material/DeleteSweep";
import { CSVLink } from "react-csv";
import DoDisturbIcon from "@mui/icons-material/DoDisturb";

import { API_URL } from "../utils/config";
const EmployeeFragment = ({ company, department }) => {
  const [companies, setCompanies] = useState([]);
  const [isList, setIsList] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [employees, setEmployees] = useState([]);
  const [employeesDownload, setEmployeesDownload] = useState([]);
  const [designations, setDesignations] = useState([]);
  const [roles, setRoles] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(company);
  const [selectedDepartment, setSelectedDepartment] = useState(department);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(8);
  const [isEdit, setIsEdit] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [sortedField, setSortedField] = useState(null);
  const [sortOrder, setSortOrder] = useState("asc");
  const [statesWithCodes, setStatesWithCodes] = useState([]);
  const [citiesWithCodes, setCitiesWithCodes] = useState([]);
  const [schoolsWithCodes, setSchoolsWithCodes] = useState([]);
  const [selectedState, setSelectedState] = useState("");
  const [selectedCity, setSelectedCity] = useState("");
  const [selectedSchool, setSelectedSchool] = useState("");
  const [flpStudentId, setFlpStudentId] = useState("");

  const [formData, setFormData] = useState({
    email: "",
    firstName: "",
    lastName: "",
    department: "",
    phoneNumber: "",
    country: "",
    city: "",
    designation: "",
    role: "",
    company: "",
    userID: localStorage.getItem("userId"), // Assuming you have the userID
  });
  // Define state to hold selected student IDs
  const [selectedEmployees, setSelectedEmployees] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  // functions to fetch the codes
  const fetchStatesWithCodes = async () => {
    try {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", localStorage.getItem("token"));
      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      const response = await fetch(
        `${API_URL}/admin/state-codes`,
        requestOptions,
      );

      if (response.status === 401) {
        localStorage.clear();
        window.location.reload();
        return;
      }

      const result = await response.json();
      setStatesWithCodes(result);
    } catch (error) {
      console.error("Error fetching states with codes:", error);
    }
  };

  const fetchCitiesWithCodes = async () => {
    try {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", localStorage.getItem("token"));
      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      const response = await fetch(
        // `${API_URL}/admin/cities-by-state/${stateId}`,
        `${API_URL}/admin/city-codes`,
        requestOptions,
      );

      if (response.status === 401) {
        localStorage.clear();
        window.location.reload();
        return;
      }

      const result = await response.json();
      setCitiesWithCodes(result);
    } catch (error) {
      console.error("Error fetching cities with codes:", error);
    }
  };

  const fetchSchoolsWithCodes = async () => {
    try {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", localStorage.getItem("token"));
      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      const response = await fetch(
        `${API_URL}/admin/school-codes`,
        requestOptions,
      );

      if (response.status === 401) {
        localStorage.clear();
        window.location.reload();
        return;
      }

      const result = await response.json();
      setSchoolsWithCodes(result);
    } catch (error) {
      console.error("Error fetching schools with codes:", error);
    }
  };

  const generateStudentId = async (
    stateId,
    cityId,
    schoolId,
    incrementSequence,
  ) => {
    try {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", localStorage.getItem("token"));
      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      const response = await fetch(
        `${API_URL}/admin/next-student-sequence?stateId=${stateId}&cityId=${cityId}&schoolId=${schoolId}&incrementSequence=${incrementSequence}`,
        requestOptions,
      );

      if (response.status === 401) {
        localStorage.clear();
        window.location.reload();
        setFlpStudentId("X0000XX000");
        setFormData({
          ...formData,
          lastName: "X0000XX000",
        });
        return "X0000XX000";
      }

      const result = await response.json();
      setFlpStudentId(result.studentId);
      setFormData({
        ...formData,
        lastName: result.studentId,
      });
      return result.studentId;
    } catch (error) {
      console.error("Error generating student ID:", error);
      return "X0000XX000";
    }
  };

  useEffect(() => {
    if (selectedState && selectedCity && selectedSchool) {
      generateStudentId(selectedState, selectedCity, selectedSchool, "false");
    }
  }, [selectedState, selectedCity, selectedSchool]);

  const handleSelectAllChange = (selectAll) => {
    if (selectAll) {
      setSelectedEmployees([]);
    } else {
      const allEmployeeIds = employees.map((student) => student._id);
      console.log(allEmployeeIds);
      setSelectedEmployees(allEmployeeIds);
    }
    setSelectAll(!selectAll);
  };

  // Function to handle checkbox change
  const handleCheckboxChange = (employeeId) => {
    // Check if the employeeId is already selected
    const selectedIndex = selectedEmployees.indexOf(employeeId);

    if (selectedIndex === -1) {
      // If not selected, add it to the array
      setSelectedEmployees([...selectedEmployees, employeeId]);
    } else {
      // If already selected, remove it from the array
      const updatedSelection = [
        ...selectedEmployees.slice(0, selectedIndex),
        ...selectedEmployees.slice(selectedIndex + 1),
      ];
      setSelectedEmployees(updatedSelection);
    }
  };

  const handleRemoveSelected = async (event) => {
    event.preventDefault();
    try {
      if (selectedEmployees.length > 0) {
        const isConfirmed = window.confirm(
          "Are you sure you want to modify these students?",
        );

        if (!isConfirmed) return; // If user cancels, do nothing
        const token = localStorage.getItem("token");
        const requestOptions = {
          method: "DELETE",
          headers: { "Content-Type": "application/json", Authorization: token },
        };

        for (const employeeId of selectedEmployees) {
          const response = await fetch(
            `${API_URL}/employee/${employeeId}`,
            requestOptions,
          );

          if (response.ok) {
            console.log(`Students ${employeeId} modify successfully`);
          } else {
            console.error(`Failed to modify student ${employeeId}`);
          }
        }

        // After deleting all selected students, you might want to refresh the student list
        fetchEmployees(); // Assuming you have fetchEmployees function defined
        setSelectedEmployees([]); // Clear selected students array
        alert("Students modify successfully");
      } else {
        alert("No student was selected!");
      }
    } catch (error) {
      console.error("Error modify students:", error);
    }
  };

  useEffect(() => {
    fetchCompanies();
    fetchRoles();
    fetchDepartments();
    fetchDesignations();
    fetchStatesWithCodes();
    // fetchCodes();
  }, []);

  useEffect(() => {
    fetchEmployees();
  }, [
    itemsPerPage,
    currentPage,
    selectedCompany,
    selectedDepartment,
    searchQuery,
  ]); // Add formData.company to the dependencies

  const handleSort = (field) => {
    if (sortedField === field) {
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      setSortedField(field);
      setSortOrder("asc");
    }
  };

  const sortedEmployees = [...employees].sort((a, b) => {
    if (sortedField) {
      const aValue = a[sortedField];
      const bValue = b[sortedField];

      if (sortOrder === "asc") {
        return aValue < bValue ? -1 : aValue > bValue ? 1 : 0;
      } else {
        return aValue > bValue ? -1 : aValue < bValue ? 1 : 0;
      }
    } else {
      return 0;
    }
  });

  const fetchRoles = async () => {
    try {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", localStorage.getItem("token"));
      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };
      fetch(`${API_URL}/role`, requestOptions)
        .then((response) => {
          if (response.status == 401) {
            localStorage.clear();
            window.location.reload();
            return [];
          } else {
            return response.json();
          }
        })
        .then((result) => setRoles(result))
        .catch((error) => console.error(error));
    } catch (error) {
      console.error(error);
    }
  };

  const fetchDepartments = async () => {
    try {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", localStorage.getItem("token"));
      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };
      fetch(`${API_URL}/department`, requestOptions)
        .then((response) => {
          if (response.status == 401) {
            localStorage.clear();
            window.location.reload();
            return [];
          } else {
            return response.json();
          }
        })
        .then((result) => setDepartments(result))
        .catch((error) => console.error(error));
    } catch (error) {
      console.error(error);
    }
  };

  const fetchDesignations = async () => {
    try {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", localStorage.getItem("token"));
      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };
      fetch(`${API_URL}/designation`, requestOptions)
        .then((response) => {
          if (response.status == 401) {
            localStorage.clear();
            window.location.reload();
            return [];
          } else {
            return response.json();
          }
        })
        .then((result) => setDesignations(result))
        .catch((error) => console.error(error));
    } catch (error) {
      console.error(error);
    }
  };

  const fetchCompanies = async () => {
    const myHeaders = new Headers();
    myHeaders.append("Authorization", localStorage.getItem("token"));
    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };
    fetch(`${API_URL}/admin/companies`, requestOptions)
      .then((response) => {
        if (response.status == 401) {
          localStorage.clear();
          window.location.reload();
          return [];
        } else {
          return response.json();
        }
      })
      .then((result) => setCompanies(result))
      .catch((error) => console.error(error));
  };

  const fetchEmployees = async () => {
    const myHeaders = new Headers();
    myHeaders.append("Authorization", localStorage.getItem("token"));
    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };
    let apiUrl = `${API_URL}/admin/employees?page=${currentPage}&limit=${itemsPerPage}`;
    if (selectedCompany) {
      apiUrl += `&companyId=${selectedCompany}`; // Append school ID if selected
    }
    if (selectedDepartment) {
      apiUrl += `&departmentId=${selectedDepartment}`; // Append department ID if selected
    }
    if (searchQuery) {
      apiUrl += `&search=${searchQuery}`; // Append search query
    }
    fetch(apiUrl, requestOptions)
      .then((response) => {
        if (response.status === 401) {
          localStorage.clear();
          window.location.reload();
          return [];
        } else {
          return response.json();
        }
      })
      .then((result) => {
        setEmployees(result.employees);
        setTotalPages(result.totalPages);
        setCurrentPage(result.currentPage);
      })
      .catch((error) => console.error(error));
    let apiUrl2 = `${API_URL}/admin/employees?page=1&limit=10000`;
    if (selectedCompany) {
      apiUrl2 += `&companyId=${selectedCompany}`;
    }
    if (selectedDepartment) {
      apiUrl2 += `&departmentId=${selectedDepartment}`;
    }
    if (searchQuery) {
      apiUrl2 += `&search=${searchQuery}`;
    }
    fetch(apiUrl2, requestOptions)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to fetch student data");
        }
        return response.json();
      })
      .then((result) => {
        setEmployeesDownload(result.employees);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // Generate student ID if needed
      generateStudentId(selectedState, selectedCity, selectedSchool, "true");
      setIsLoading(true);

      // Log the data being sent
      console.log("Sending employee data:", {
        email: formData.email,
        firstName: formData.firstName,
        lastName: formData.lastName,
        department: formData.department,
        phoneNumber: formData.phoneNumber,
        country: formData.country,
        city: formData.city,
        designation: formData.designation,
        role: formData.role,
        company: formData.company,
        userID: localStorage.getItem("userId"),
      });

      const companyResponse = await fetch(
        `${API_URL}/admin/register-employee`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("token"),
          },
          body: JSON.stringify({
            email: formData.email,
            firstName: formData.firstName,
            lastName: formData.lastName,
            department: formData.department,
            phoneNumber: formData.phoneNumber,
            country: formData.country,
            city: formData.city,
            designation: formData.designation,
            role: formData.role,
            company: formData.company,
            userID: localStorage.getItem("userId"),
          }),
        },
      );

      // Get the detailed error message
      const responseData = await companyResponse.json();

      if (!companyResponse.ok) {
        console.error("Server error:", responseData);
        throw new Error(responseData.error || "Failed to add student");
      }

      setFormData({
        email: "",
        firstName: "",
        lastName: "",
        department: "",
        phoneNumber: "",
        country: "",
        city: "",
        designation: "",
        role: "",
        company: "",
        userID: localStorage.getItem("userId"), // Assuming you have the userID
      });

      // Reset selection states
      setSelectedState("");
      setSelectedCity("");
      setSelectedSchool("");
      setFlpStudentId("");

      alert("Students created successfully");
      await fetchEmployees();
      setIsLoading(false);
      setIsList(true);
    } catch (error) {
      console.error("Error creating student:", error);
      alert("There was an error creating student: " + error.message);
      setIsLoading(false);
    }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleDelete = async (employeeId) => {
    // Display confirmation popup before deleting
    const isConfirmed = window.confirm(
      "Are you sure you want to delete this student?",
    );

    if (!isConfirmed) return; // If user cancels, do nothing

    try {
      const token = localStorage.getItem("token"); // Get the authentication token
      const requestOptions = {
        method: "DELETE",
        headers: { "Content-Type": "application/json", Authorization: token },
      };

      const response = await fetch(
        `${API_URL}/employee/${employeeId}`,
        requestOptions,
      );

      if (response.ok) {
        alert("Students deleted successfully");
        fetchEmployees();
      } else {
        throw new Error("Failed to modify student");
      }
    } catch (error) {
      console.error("Error modify student:", error);
      alert("Failed to modify student");
    }
  };

  const handleEdit = async (course) => {
    setFormData({
      employeeID: course._id,
      email: course.email,
      firstName: course.firstName,
      lastName: course.lastName,
      department: course.department ? course.department._id : "",
      phoneNumber: course.phoneNumber,
      country: course.country,
      city: course.city,
      designation: course.designation,
      role: course.role,
      company: course.company._id,
      userID: localStorage.getItem("userId"),
    });

    // Set FLP Student Id for display
    setFlpStudentId(course.lastName || "");

    // Fetch all codes so dropdowns are populated before matching
    const myHeaders = new Headers();
    myHeaders.append("Authorization", localStorage.getItem("token"));
    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    try {
      const [citiesRes, schoolsRes] = await Promise.all([
        fetch(`${API_URL}/admin/city-codes`, requestOptions),
        fetch(`${API_URL}/admin/school-codes`, requestOptions),
      ]);
      const cities = await citiesRes.json();
      const schools = await schoolsRes.json();
      setCitiesWithCodes(cities);
      setSchoolsWithCodes(schools);

      // Match school by company ID
      const matchedSchool = schools.find(
        (s) => s.company.toString() === course.company._id.toString(),
      );
      if (matchedSchool) {
        setSelectedState(matchedSchool.state.toString());
        setSelectedCity(matchedSchool.city.toString());
        setSelectedSchool(matchedSchool.id);
      } else {
        setSelectedState("");
        setSelectedCity("");
        setSelectedSchool("");
      }
    } catch (err) {
      console.error("Error loading codes for edit:", err);
    }

    setIsEdit(true);
    setIsList(false);
  };

  const handleModify = async (e) => {
    e.preventDefault();
    try {
      setIsLoading(true);
      const companyResponse = await fetch(
        `${API_URL}/admin/employee/${formData.employeeID}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("token"), // Replace with your JWT token
          },
          body: JSON.stringify({
            email: formData.email,
            firstName: formData.firstName,
            lastName: formData.lastName,
            department: formData.department,
            phoneNumber: formData.phoneNumber,
            country: formData.country,
            city: formData.city,
            designation: formData.designation,
            role: formData.role,
            company: formData.company,
            userID: localStorage.getItem("userId"), // Assuming you have the userID
          }),
        },
      );
      if (!companyResponse.ok) {
        throw new Error("Failed to add school");
      }
      setFormData({
        email: "",
        firstName: "",
        lastName: "",
        department: "",
        phoneNumber: "",
        country: "",
        city: "",
        designation: "",
        role: "",
        company: "",
        userID: localStorage.getItem("userId"), // Assuming you have the userID
      });
      // Reset selection states
      setSelectedState("");
      setSelectedCity("");
      setSelectedSchool("");
      setFlpStudentId("");

      alert("Students modified successfully");
      await fetchEmployees();
      setIsLoading(false);
      setIsEdit(false);
      setIsList(true);
    } catch (error) {
      alert("There was a error modifying student, please try again.");
      setIsLoading(false);
    }
  };

  return (
    <Grid
      item
      xs={10}
      style={{
        padding: "20px",
        height: "100%",
        fontFamily: "Noto Sans",
        fontWeight: "500",
        justifyContent: "center",
        alignContent: "center",
        alignItems: "center",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Container fluid style={{ height: "100%" }}>
        <div
          style={{
            marginBottom: "15px",
            justifyContent: "space-between",
            alignContent: "center",
            alignItems: "center",
            display: "flex",
            flexDirection: "row",
          }}
        >
          {isList ? (
            <div
              style={{
                display: "flex",
                width: "30%",
                flexDirection: "row",
                justifyContent: "start",
                alignItems: "start",
              }}
            >
              <Form.Group controlId="formCompanyFilter" style={{ flex: 1 }}>
                <Form.Control
                  className="w-100"
                  style={{ borderRadius: "10px" }}
                  as="select"
                  value={selectedCompany}
                  onChange={(e) => {
                    setSelectedCompany(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">All Schools</option>
                  {companies.map((company) => (
                    <option key={company._id} value={company._id}>
                      {company.name}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>
              <div style={{ width: "10px" }} />
              <Form.Group controlId="formCompanyFilter" style={{ flex: 1 }}>
                <Form.Control
                  className="w-100"
                  style={{ borderRadius: "10px" }}
                  as="select"
                  value={selectedDepartment}
                  onChange={(e) => {
                    setSelectedDepartment(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">All Class</option>
                  {departments.map((department) => (
                    <option key={department._id} value={department._id}>
                      {department.name}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>
            </div>
          ) : (
            <h4>{isEdit ? "Edit" : "Create"} Students</h4>
          )}

          {!isEdit && isList && (
            <>
              <Form.Control
                style={{
                  borderRadius: "10px",
                  marginRight: "10px",
                  flex: 1,
                  marginLeft: "10px",
                }}
                type="text"
                placeholder="Search..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
              <Button
                style={{
                  marginRight: "5px",
                  fontWeight: "600",
                  borderRadius: "20px",
                  backgroundColor: "green",
                  borderColor: "green",
                }}
                elevation={3}
                variant="primary"
                type="button"
                onClick={() => {
                  document.getElementById("csvUpload").click();
                }}
              >
                Upload
              </Button>
              <Button
                style={{
                  marginRight: "5px",
                  fontWeight: "600",
                  borderRadius: "20px",
                  backgroundColor: "red",
                  borderColor: "red",
                }}
                elevation={3}
                variant="primary"
                type="button"
                onClick={() => {
                  const csvContent =
                    "school,email,firstName,department,phoneNumber,country,city,designation,role\n" +
                    "67975924ba4b6dbdbcac38e1,johndoe@gmail.com,John Doe,678e08da5a5e99fb43ac784e,1234567890,USA,New York,678e08fe5a5e99fb43ac78a8,678e09065a5e99fb43ac78b7";
                  const blob = new Blob([csvContent], {
                    type: "text/csv;charset=utf-8;",
                  });
                  const link = document.createElement("a");
                  const url = URL.createObjectURL(blob);
                  link.setAttribute("href", url);
                  link.setAttribute("download", "sample.csv");
                  link.style.visibility = "hidden";
                  document.body.appendChild(link);
                  link.click();
                  document.body.removeChild(link);
                }}
              >
                Sample CSV
              </Button>
              <Button
                variant="outline-primary"
                style={{
                  marginRight: "5px",
                  fontWeight: "600",
                  borderRadius: "20px",
                }}
                elevation={3}
              >
                <CSVLink
                  data={employeesDownload.map((student, index) => ({
                    "First Name": student.firstName,
                    "Roll No": student.lastName,
                    Course: student.department
                      ? student.department.name
                      : "N/A",
                    Email: student.email,
                    Phone: student.phone,
                    School: student.company.name,
                    Country: student.country,
                    City: student.city,
                  }))}
                  filename={"data.csv"}
                  target="_blank"
                >
                  Download
                </CSVLink>
              </Button>
              <Button
                style={{
                  fontWeight: "600",
                  borderRadius: "20px",
                  backgroundColor: "red",
                  borderColor: "red",
                  marginRight: "5px",
                }}
                elevation={3}
                variant="primary"
                type="button"
                disabled={isLoading}
                onClick={handleRemoveSelected}
              >
                Toggle Status
              </Button>
            </>
          )}

          <Button
            style={{ fontWeight: "600", borderRadius: "20px" }}
            elevation={3}
            className="w-10"
            variant="primary"
            type="submit"
            disabled={isLoading}
            onClick={(event) => {
              event.preventDefault();
              setIsList(!isList);
              setIsEdit(false);
              setFormData({
                email: "",
                firstName: "",
                lastName: "",
                department: "",
                phoneNumber: "",
                country: "",
                city: "",
                designation: "",
                role: "",
                company: "",
                userID: localStorage.getItem("userId"),
              });
            }}
          >
            {isList ? "Create" : "Cancel"}
          </Button>
        </div>
        <input
          id="csvUpload"
          type="file"
          style={{ display: "none" }}
          accept=".csv"
          onChange={async (event) => {
            const file = event.target.files[0];
            const myHeaders = new Headers();
            myHeaders.append("Authorization", localStorage.getItem("token"));
            const formdata = new FormData();
            formdata.append("csvFile", file, "test.csv");
            formdata.append("userID", localStorage.getItem("userId"));

            const requestOptions = {
              method: "POST",
              headers: myHeaders,
              body: formdata,
              redirect: "follow",
            };

            await fetch(
              `${API_URL}/admin/register-employees-from-csv`,
              requestOptions,
            )
              .then((response) => response.json())
              .then((result) => alert(result.message))
              .catch((error) => console.error(error));
            fetchEmployees();
          }}
        />
        <Row>
          {isList ? (
            <Col
              xs={12}
              style={{
                overflowY: "scroll",
                flex: 1,
                width: "100%",
                height: "83vh",
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
            >
              <div style={{ width: "100%" }}>
                {employees.length > 0 ? (
                  <Table striped bordered hover>
                    <thead>
                      <tr>
                        <th>
                          <input
                            type="checkbox"
                            checked={selectAll}
                            onChange={() => handleSelectAllChange(selectAll)}
                          />
                        </th>
                        <th onClick={() => handleSort("firstName")}>Name</th>
                        <th onClick={() => handleSort("lastName")}>
                          Last Login
                        </th>
                        <th onClick={() => handleSort("department.name")}>
                          Class
                        </th>
                        <th onClick={() => handleSort("email")}>Email</th>
                        <th onClick={() => handleSort("company.name")}>
                          School
                        </th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {sortedEmployees.map((student, index) => (
                        <tr key={student._id}>
                          <td
                            style={{
                              width: "100%",
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                              justifyContent: "space-evenly",
                            }}
                          >
                            <div
                              style={{
                                backgroundColor: student.active
                                  ? "green"
                                  : "red",
                                width: "10px",
                                height: "50px",
                              }}
                            />
                            <input
                              style={{ margin: "0px", padding: "0px" }}
                              checked={selectedEmployees.includes(student._id)}
                              type="checkbox"
                              onChange={() => handleCheckboxChange(student._id)}
                            />
                          </td>
                          <td>{student.firstName}</td>
                          <td>
                            {new Date(student.logintime).toLocaleString()}
                            <p
                              style={{
                                margin: "0px",
                                padding: "0px",
                                fontSize: "10px",
                              }}
                            >
                              {student.ip}
                            </p>
                          </td>
                          <td>
                            {student.department
                              ? student.department.name
                              : "N/A"}
                          </td>
                          <td>
                            {student.email}
                            <p
                              style={{
                                margin: "0px",
                                padding: "0px",
                                fontSize: "10px",
                              }}
                            >
                              {student._id}
                            </p>
                          </td>
                          <td>{student.company.name}</td>
                          <td>
                            <EditNoteIcon
                              onClick={() => handleEdit(student)}
                              style={{ color: "blue", cursor: "pointer" }}
                            />
                            <DoDisturbIcon
                              onClick={() => handleDelete(student._id)}
                              style={{ color: "blue", cursor: "pointer" }}
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                ) : (
                  <div style={{ margin: "20px", textAlign: "center" }}>
                    No student found, please try again!
                  </div>
                )}
              </div>
              <div style={{ flex: 1 }} />
              {employees.length > 0 ? (
                <nav aria-label="Courses pagination">
                  <ul
                    className="pagination"
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <li className="page-item">
                      <select
                        className="form-select form-select-sm"
                        aria-label="Default select example"
                        value={itemsPerPage}
                        onChange={(e) => {
                          setCurrentPage(1);
                          setItemsPerPage(parseInt(e.target.value));
                        }}
                        style={{ height: "40px" }} // Set the height to 100%
                      >
                        <option value="8">8 per page</option>
                        <option value="15">15 per page</option>
                        <option value="50">50 per page</option>
                        <option value="100">100 per page</option>
                      </select>
                    </li>
                    <div style={{ width: "10px" }} />
                    {[...Array(totalPages).keys()].map((page) => (
                      <li
                        key={page}
                        className={`page-item ${
                          currentPage === page + 1 ? "active" : ""
                        }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => handlePageChange(page + 1)}
                        >
                          {page + 1}
                        </button>
                      </li>
                    ))}
                  </ul>
                </nav>
              ) : null}
            </Col>
          ) : (
            <Row>
              <Col xs={6}>
                <Form style={{ fontFamily: "Noto Sans" }} className="w-100">
                  <Form.Group controlId="formCompany">
                    <Form.Label
                      style={{ fontWeight: "500", borderRadius: "20px" }}
                    >
                      School<span style={{ color: "red" }}> *</span>
                    </Form.Label>
                    <Form.Control
                      className="w-100"
                      style={{ width: "100%", borderRadius: "20px" }}
                      as="select"
                      value={selectedSchool}
                      onChange={(e) => {
                        const schoolId = e.target.value;
                        setSelectedSchool(schoolId);
                        const selectedSchoolObj = schoolsWithCodes.find(
                          (school) => school.id === schoolId,
                        );

                        if (selectedSchoolObj) {
                          // Find the matching company from the companies array using the school name
                          const matchingCompany = companies.find(
                            (company) =>
                              company.name === selectedSchoolObj.companyName,
                          );

                          if (matchingCompany) {
                            console.log(
                              "Found matching company:",
                              matchingCompany,
                            );
                            setFormData({
                              ...formData,
                              company: matchingCompany._id, // Use the MongoDB ObjectId from companies array
                            });
                          } else {
                            console.error(
                              "No matching company found for:",
                              selectedSchoolObj.companyName,
                            );
                          }
                        }
                      }}
                      disabled={!selectedCity}
                    >
                      <option value="">Select a school</option>
                      {schoolsWithCodes.map((school) => (
                        <option key={school.id} value={school.id}>
                          {school.companyName} ({school.code})
                        </option>
                      ))}
                    </Form.Control>
                  </Form.Group>
                  <Form.Group controlId="formCompanyName">
                    <Form.Label
                      style={{ fontWeight: "500", borderRadius: "20px" }}
                    >
                      Email<span style={{ color: "red" }}> *</span>
                    </Form.Label>
                    <Form.Control
                      className="w-100"
                      style={{ width: "100%", borderRadius: "20px" }}
                      type="text"
                      placeholder="Email"
                      value={formData.email}
                      onChange={(e) =>
                        setFormData({ ...formData, email: e.target.value })
                      }
                    />
                  </Form.Group>
                  <Form.Group controlId="formCompanyDescription">
                    <Form.Label
                      style={{ fontWeight: "500", borderRadius: "20px" }}
                    >
                      Full Name<span style={{ color: "red" }}> *</span>
                    </Form.Label>
                    <Form.Control
                      className="w-100"
                      style={{ width: "100%", borderRadius: "20px" }}
                      type="text"
                      placeholder="First Name"
                      value={formData.firstName}
                      onChange={(e) =>
                        setFormData({ ...formData, firstName: e.target.value })
                      }
                    />
                  </Form.Group>
                  <Form.Group controlId="formCompanyCategory">
                    <Form.Label
                      style={{ fontWeight: "500", borderRadius: "20px" }}
                    >
                      FLP Student Id<span style={{ color: "red" }}> *</span>
                    </Form.Label>
                    <Form.Control
                      className="w-100"
                      style={{ width: "100%", borderRadius: "20px" }}
                      type="text"
                      placeholder="FLP Student Id"
                      value={flpStudentId}
                      readOnly
                    />
                  </Form.Group>
                  <Form.Group controlId="formCompanyEmployees">
                    <Form.Label
                      style={{ fontWeight: "500", borderRadius: "20px" }}
                    >
                      Phone Number
                    </Form.Label>
                    <Form.Control
                      className="w-100"
                      style={{ width: "100%", borderRadius: "20px" }}
                      type="text"
                      placeholder="Phone Number"
                      value={formData.phoneNumber}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          phoneNumber: e.target.value,
                        })
                      }
                    />
                  </Form.Group>
                </Form>
              </Col>
              <Col xs={6}>
                <Form style={{ fontFamily: "Noto Sans" }} className="w-100">
                  <Form.Group controlId="formCompanyState">
                    <Form.Label
                      style={{ fontWeight: "500", borderRadius: "20px" }}
                    >
                      State<span style={{ color: "red" }}> *</span>
                    </Form.Label>
                    <Form.Control
                      className="w-100"
                      style={{ width: "100%", borderRadius: "20px" }}
                      as="select"
                      value={selectedState}
                      onChange={(e) => {
                        const stateId = e.target.value;
                        setSelectedState(stateId);
                        setSelectedCity("");

                        if (stateId) {
                          const selectedStateObj = statesWithCodes.find(
                            (state) => state.id === stateId,
                          );
                          if (selectedStateObj) {
                            // console.log(
                            //   "Selected State Name:",
                            //   selectedStateObj.name
                            // );
                            setFormData({
                              ...formData,
                              country: selectedStateObj.name,
                            });
                          }
                        }
                        fetchCitiesWithCodes(stateId);
                      }}
                    >
                      <option value="">Select a state</option>
                      {statesWithCodes.map((state) => (
                        <option key={state.id} value={state.id}>
                          {state.name} ({state.code})
                        </option>
                      ))}
                    </Form.Control>
                  </Form.Group>

                  <Form.Group controlId="formCompanyCity">
                    <Form.Label
                      style={{ fontWeight: "500", borderRadius: "20px" }}
                    >
                      City<span style={{ color: "red" }}> *</span>
                    </Form.Label>
                    <Form.Control
                      className="w-100"
                      style={{ width: "100%", borderRadius: "20px" }}
                      as="select"
                      value={selectedCity}
                      onChange={(e) => {
                        const cityId = e.target.value;
                        setSelectedCity(cityId);
                        if (cityId) {
                          const selectedCityObj = citiesWithCodes.find(
                            (city) => city.id === cityId,
                          );
                          if (selectedCityObj) {
                            //   console.log(
                            //     "Selected City Name:",
                            //     selectedCityObj.name
                            //   );
                            setFormData({
                              ...formData,
                              city: selectedCityObj.name,
                            });
                          }
                        }
                        fetchSchoolsWithCodes(e.target.value);
                      }}
                      disabled={!selectedState}
                    >
                      <option value="">Select a city</option>
                      {citiesWithCodes.map((city) => (
                        <option key={city.id} value={city.id}>
                          {city.name} ({city.code})
                        </option>
                      ))}
                    </Form.Control>
                  </Form.Group>

                  <Form.Group controlId="formCompany">
                    <Form.Label
                      style={{ fontWeight: "500", borderRadius: "20px" }}
                    >
                      Level<span style={{ color: "red" }}> *</span>
                    </Form.Label>
                    <Form.Control
                      className="w-100"
                      style={{ width: "100%", borderRadius: "20px" }}
                      as="select"
                      value={formData.department}
                      onChange={(e) =>
                        setFormData({ ...formData, department: e.target.value })
                      }
                    >
                      <option value="">Select a Level</option>
                      {departments.map((department) => (
                        <option key={department._id} value={department._id}>
                          {department.name}
                        </option>
                      ))}
                    </Form.Control>
                  </Form.Group>
                  <Form.Group controlId="formCompany">
                    <Form.Label
                      style={{ fontWeight: "500", borderRadius: "20px" }}
                    >
                      Grade<span style={{ color: "red" }}> *</span>
                    </Form.Label>
                    <Form.Control
                      className="w-100"
                      style={{ width: "100%", borderRadius: "20px" }}
                      as="select"
                      value={formData.designation}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          designation: e.target.value,
                        })
                      }
                    >
                      <option value="">Select a Grade</option>
                      {designations.map((designation) => (
                        <option key={designation._id} value={designation._id}>
                          {designation.name}
                        </option>
                      ))}
                    </Form.Control>
                  </Form.Group>
                  <Form.Group controlId="formCompany">
                    <Form.Label
                      style={{ fontWeight: "500", borderRadius: "20px" }}
                    >
                      Batch<span style={{ color: "red" }}> *</span>
                    </Form.Label>
                    <Form.Control
                      className="w-100"
                      style={{ width: "100%", borderRadius: "20px" }}
                      as="select"
                      value={formData.role}
                      onChange={(e) =>
                        setFormData({ ...formData, role: e.target.value })
                      }
                    >
                      <option value="">Select a Batch</option>
                      {roles.map((role) => (
                        <option key={role._id} value={role._id}>
                          {role.name}
                        </option>
                      ))}
                    </Form.Control>
                  </Form.Group>
                </Form>
              </Col>
              <Col
                xs={12}
                style={{
                  justifyContent: "center",
                  alignContent: "center",
                  alignItems: "center",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <Button
                  onClick={isEdit ? handleModify : handleSubmit}
                  style={{
                    fontWeight: "600",
                    borderRadius: "20px",
                    marginTop: "15px",
                  }}
                  elevation={3}
                  className="w-25"
                  variant="primary"
                  type="submit"
                  disabled={isLoading}
                >
                  {isLoading ? (
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  ) : null}
                  {isEdit ? "Edit" : "Create"} Students
                </Button>
              </Col>
            </Row>
          )}
        </Row>
      </Container>
    </Grid>
  );
};
export default EmployeeFragment;
